import {
  useIsEligibleForAddPaymentMethodFlowExperiment,
  useSelectedPaymentMethod,
  useSelectedPaymentType,
  useShouldRoutePi4SwitcherWithNoPaymentMethodToSummary,
} from '../../state'

export const useIsMissingPaymentMethod = (): boolean => {
  const isAddPaymentMethodFlowExperiment = useIsEligibleForAddPaymentMethodFlowExperiment()
  const selectedPaymentType = useSelectedPaymentType()
  const shouldRoutePi4SwitcherWithNoPaymentMethodToSummary = useShouldRoutePi4SwitcherWithNoPaymentMethodToSummary(selectedPaymentType)
  const initialSelectedPaymentMethod = useSelectedPaymentMethod()

  return (isAddPaymentMethodFlowExperiment || shouldRoutePi4SwitcherWithNoPaymentMethodToSummary) && !initialSelectedPaymentMethod
}
